import sileo from 'sileo';

const AdministrativeLeave = new sileo.Model('hqzen', 'administrative-leaves');
const AdminLeaveAttachmentAmazonForm = new sileo.Model('hqzen', 'admin-leave-attachment-amazon-form-data');
const ReinstatementRequest = new sileo.Model('hqzen', 'reinstatement-requests');
const ReinstatementRequestAttachmentAmazonForm = new sileo.Model(
    'hqzen', 'reinstatement-requests-attachment-amazon-form-data');
const AdministrativeLeaveList = new sileo.Model('hqzen', 'administrative-leave-list');
const ReinstatementRequestAcknowledgement = new sileo.Model('hqzen', 'reinstatement-requests-acknowledgement');
const ArchiveAdministrativeLeave = new sileo.Model('hqzen', 'archive-administrative-leaves');


const state = {};

const getters = {};

const mutations = {};

const actions = {

    createReinstatementRequest(context, data) {
        const form = new FormData();
        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return ReinstatementRequest.objects.create(form);
    },

    updateReinstatementRequest(context, data) {
        let pk = data.pk;
        let form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }

        return ReinstatementRequest.objects.update({ pk }, form);
    },

    acknowledgeReinstatementRequest(context, data) {
        let form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }

        return ReinstatementRequestAcknowledgement.objects.create(form);
    },

    archiveAdministrativeLeave(context, data) {
        let pk = data.pk;
        let form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }

        return ArchiveAdministrativeLeave.objects.update({ pk }, form);
    },

    async fetchReinstatementRequestAttachmentAmazonFormData(context, file_type) {
        return ReinstatementRequestAttachmentAmazonForm.objects.filter(
            { file_type: file_type }).then(data => {
                return data.amazon;
            });
    },

    async fetchReinstatementRequestSignatureAmazonFormData(context, file_type) {
        return await ReinstatementRequestAttachmentAmazonForm.objects.filter(
            { file_type: file_type,
              signature_attachment: true }).then(data => {
            return data.amazon;
        });
    },

    async fetchReinstatementRequests(context, filters) {
        return ReinstatementRequest.objects.filter(filters);
    },

    async fetchAdministrativeLeaves(context, filters) {
        return AdministrativeLeave.objects.filter(filters);
    },

    createAdministrativeLeave(context, data) {
        const form = new FormData();
        return new Promise((resolve, reject) => {
            data.signature_file.save(async (blob) => {
                data['signature_file'] = blob;
                Object.keys(data).forEach(key => {
                    form.append(key, data[key]);
                });
                try {
                    resolve(await AdministrativeLeave.objects.create(form));
                } catch (e) {
                    resolve(e);
                }
            });
        });
    },

    async fetchAdminLeaveAttachmentAmazonFormData(context, file_type) {
        return AdminLeaveAttachmentAmazonForm.objects.filter(
            { file_type: file_type }).then(data => {
                return data.amazon;
            });
    },

    fetchAdministrativeLeaveList(context, filters) {
        return AdministrativeLeaveList.objects.filter(filters);
    },

    getAdministrativeLeaveDetails(context, pk) {
        return AdministrativeLeave.objects.get(pk);
    }

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
